<template>

<div class="404-content">

    <header class="page-header">
        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <!-- Breadcrumbs -->
                    <nav aria-label="breadcrumb" class="breadcrumb-holder">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a></li>
                            <li class="pl-1 pr-1"><span class="icon icon-arrow-right1"></span></li>
                            <li class="breadcrumb-item active" aria-current="page">
                                Error 404
                            </li>
                        </ol>
                    </nav>

                    <h1 class="page-title">
                        Error 404
                    </h1>
                </div>
            </div>
        </div>
    </header>

    <section class="content-section">
        <div class="container">
            <div class="row d-flex justify-content-center">
                <div class="col-12 col-lg-9 col-xl-7 text-center">
                    <img src="/resources/images/beach.svg" alt="Page 404" width="150px" class="img-fluid mb-4">
                    <p>Sorry, the page you are looking for could not be found.</p>
                    <a href="/" class="btn btn-primary btn-lg">
                        <span class="icon icon-arrow-left1 mr-2"></span>
                        Go to homepage
                    </a>
                </div>
            </div>
        </div>
    </section>
    
</div>

</template>

<script>
    export default {

        mounted() {
            document.body.classList.add('page-404')
        },

        created() {
           
        },

        data() {
            return {
                isReady : false,
            }
        },

        methods : {

        },

        destroyed () {
            document.body.classList.remove('page-404')
        }

    }
</script>
